<template>
<div class="large-container">
	<Tabs v-model="tabName" @on-click="tabChange" v-if="companyUpdated">
		<TabPane label="参保人员" name="Insured">
			<keep-alive>
				<Insured v-if="tabName=='Insured'" ref="Insured" @to="tabChange"></Insured>
			</keep-alive>
		</TabPane>
		<TabPane label="结算名单" name="SettlementList">
			<keep-alive>
				<SettlementList v-if="tabName=='SettlementList'" ref="SettlementList"></SettlementList>
			</keep-alive>
		</TabPane>
		<TabPane label="参保公司" name="Company">
			<keep-alive>
				<Company v-if="tabName=='Company'" ref="Company"></Company>
			</keep-alive>
		</TabPane>
	</Tabs>
</div>
</template>
<script>
import Insured from './list/Insured'
import SettlementList from './list/SettlementList'
import Company from './list/Company'
import Qs from 'qs'
export default {
	components:{Insured,SettlementList,Company},
	data () {
		return {
			tabName: 'Insured',
			companyUpdated:false
		}
	},
	created () {
		this.updateBindCompany()
		if(this.$route.query.tab){
			this.tabName=this.$route.query.tab
		}
	},
	methods: {
		// 更新绑定的公司
		updateBindCompany(){
			this.$axios.post('/guarantee/bindUser.all',{
				productCode:'JIN_KONG'
			}).then(res=>{
				if(res.code==10000000){
					this.companyUpdated=true
				}else if(res.code==10000012){
					if(location.href&&location.href.indexOf('/common.html#/login')==-1){
						window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
					}
				}else{
					this.$Modal.error({
						title:'提示',
						content:res.msg,
						okText:'返回产品专区',
						onOk:()=>{
							// location.href="/haierProduct.html#/"
							location.href="/company"
						}
					})
				}
			})
		},
		tabChange (value) {
			let query={
				...this.$route.query,
				tab:value
			}
			this.tabName=value;
			
			this.$router.replace(`/jinkong?${Qs.stringify(query)}`)
			this.$nextTick(()=>{
				if(this.$refs[this.tabName]){
					this.$refs[this.tabName].search()
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/jinkong/Index.vue